/** Simpler version `typographyTemplate` that does not set `color` and `margin` */
var typographyMixin = function typographyMixin(typography) {
  var fontFamily = typography.fontFamily,
    fontSize = typography.fontSize,
    fontWeight = typography.fontWeight,
    lineHeight = typography.lineHeight,
    letterSpacing = typography.letterSpacing,
    fontFeature = typography.fontFeature,
    textDecoration = typography.textDecoration,
    textTransform = typography.textTransform,
    fontStyle = typography.fontStyle;
  return {
    fontFeatureSettings: fontFeature,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeight: fontWeight,
    letterSpacing: letterSpacing,
    lineHeight: lineHeight,
    textDecoration: textDecoration,
    textTransform: textTransform,
    fontStyle: fontStyle
  };
};

export { typographyMixin };
